import React, { useState } from 'react';
import { Typography, Box } from '@mui/material';
import { useNavigateWithScrollMemory } from '../../hooks/useNavigateWithScrollMemory';
import defaultArtistThumbnail from '../../assets/default_artist_thumbnail.svg';
import { Link } from 'react-router-dom';
import { trackArtistContentClick } from '../../lib/gaEvents';
import { CONTENT_TYPE, ARTIST_ACTION_TYPE } from '../../constants/gaEnums';
import { useUserStore } from '../../stores/userStore';

const ArtistCard = ({
  id,
  artistDbId,
  name,
  artistImageUrl,
  artistSource,
  slug,
  enableOnClick = true,
  referrerType,
  referrerSection,
  artistSection,
  pageType,
}) => {
  const navigateWithScrollMemory = useNavigateWithScrollMemory();
  const user = useUserStore((state) => state.user);
  const [imageError, setImageError] = useState(false);
  const canClickToArtist = enableOnClick && id !== 'unknown';
  const artistUrl = slug
    ? artistDbId
      ? `/artists/${slug}`
      : `/artists/${slug}?source_id=${id}`
    : `/artists/${artistSource?.toLowerCase()}/${id}`;

  const artistLinkState = {
    sourceId: id,
    sourceType: artistSource,
    ...(referrerType && { referrerType }),
    ...(referrerSection && { referrerSection }),
  };

  const handleClickToArtist = (e) => {
    if (!e.metaKey && !e.ctrlKey) {
      e.preventDefault();
      if (artistSection) {
        trackArtistContentClick(
          {
            artistSection,
            actionType: ARTIST_ACTION_TYPE.ARTIST_CLICK,
            contentType: CONTENT_TYPE.ARTIST,
            contentId: id,
            contentName: name,
            pageType,
          },
          user,
        );
      }
      navigateWithScrollMemory(artistUrl, { state: artistLinkState });
    }
  };

  const handleError = () => {
    if (!imageError) {
      setImageError(true);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: { xs: 1, md: 1.5, lg: 2 },
        position: 'relative',
      }}
    >
      <Link
        to={canClickToArtist ? artistUrl : undefined}
        state={canClickToArtist ? artistLinkState : undefined}
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'block',
          width: '100%',
        }}
      >
        <Box
          component="img"
          src={imageError || !artistImageUrl ? defaultArtistThumbnail : artistImageUrl}
          alt={name}
          loading="lazy"
          onClick={canClickToArtist ? handleClickToArtist : undefined}
          onError={handleError}
          sx={{
            aspectRatio: '1 / 1',
            objectFit: 'cover',
            width: '100%',
            cursor: canClickToArtist ? 'pointer' : 'default',
          }}
        />
      </Link>
      <Link
        to={canClickToArtist ? artistUrl : undefined}
        state={canClickToArtist ? artistLinkState : undefined}
        style={{
          textDecoration: 'none',
          color: 'inherit',
          display: 'block',
          width: '100%',
        }}
      >
        <Typography
          onClick={canClickToArtist ? handleClickToArtist : undefined}
          sx={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            fontSize: { xs: 14, md: 14, lg: 16 },
            fontWeight: 700,
            cursor: canClickToArtist ? 'pointer' : 'default',
            lineHeight: '1.5',
          }}
        >
          {name}
        </Typography>
      </Link>
    </Box>
  );
};

export default ArtistCard;
